import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "../ui/button";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const TicketHeader = ({ loading, children }) => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/tickets");
  };

  if (loading) {
    return <TicketHeaderSkeleton />;
  }

  return (
    // No celular as ações não cabem ao lado do nome: com atendimento aberto
    // são sete controles, e o nome do contato era espremido até virar "E..".
    // Com o flex-wrap elas descem para uma segunda linha — custa uns 40px de
    // altura e devolve o nome inteiro, em vez de esconder botão.
    <div className="flex flex-none flex-wrap items-center gap-x-2 gap-y-1.5 border-b bg-background px-3 py-2 shadow-xs">
      <Button
        variant="ghost"
        size="icon"
        onClick={handleBack}
        className="shrink-0 sm:hidden"
      >
        <ChevronLeft className="h-5 w-5" />
      </Button>
      {children}
    </div>
  );
};

export default TicketHeader;
